import React from 'react';

import { Button } from '@fragment/ui/src/components/Button/BaseButton/Button';
import { ErrorText } from '@fragment/ui/src/components/ErrorText';

type Props = {
  isLoading: boolean;
  message: string | undefined;
  errorMessage: string | undefined;
  onContinue: () => void;
};

export const ConnectionSignIn = ({
  isLoading,
  message,
  errorMessage,
  onContinue,
}: Props) => (
  <div className="space-y-f4 pt-f4">
    <div className="flex flex-col items-start gap-f1">
      <Button
        type="button"
        padding="px-[1ch] py-fhalf"
        background="bg-main hover:bg-negative disabled:bg-main-200"
        color="text-negative hover:text-main disabled:text-main-500"
        fontDecoration="no-underline"
        extraClassNames="text-[inherit] leading-[inherit] cursor-pointer disabled:cursor-not-allowed"
        disabled={isLoading}
        aria-busy={isLoading}
        onClick={onContinue}
      >
        Continue with Google
      </Button>
      <Button
        type="button"
        padding="px-[1ch] py-fhalf"
        background="bg-main-200 hover:bg-negative"
        color="text-main disabled:text-main-500"
        fontDecoration="no-underline"
        extraClassNames="text-[inherit] leading-[inherit] cursor-pointer disabled:cursor-not-allowed"
        onClick={() =>
          window.open(
            'https://cal.com/team/fragment/ledger',
            '_blank',
            'noopener,noreferrer'
          )
        }
      >
        Book a Demo
      </Button>
    </div>
    {message && <p>{message}</p>}
    {errorMessage && <ErrorText>{errorMessage}</ErrorText>}
    <p className="text-main-500">
      By continuing, you agree to our{' '}
      <a
        href="https://fragment.dev/legal"
        className="text-main-500 underline decoration-main-500"
      >
        terms of use and privacy policy
      </a>
      .
    </p>
  </div>
);
